<template>
  <div class="data-card">
    <div class="data-card__icon" v-if="$slots.icon">
      <slot name="icon"></slot>
    </div>
    <div class="data-card__body" :style="bodyStyle">
      <div class="data-card__title">
        <slot name="title" v-if="$slots.title"></slot>
        <template v-else>{{ title }}</template>
      </div>
      <div class="data-card__value">
        <slot name="value" v-if="$slots.value"></slot>
        <template v-else>
          <span class="data-card__text" :style="valueStyle">{{ value }}</span>
          <span class="data-card__unit" v-if="unit">{{ unit }}</span>
        </template>
      </div>
    </div>
  </div>
</template>



<script setup>
import { computed } from 'vue'



const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  value: {
    type: String,
    default: ''
  },
  unit: {
    type: String,
    default: ''
  },
  valueStyle: {
    type: [Object, String],
    default: () => ({})
  },
  titlePosition: {
    type: String,
    default: 'top',
    validator: (val) => ['right', 'left', 'top', 'bottom'].includes(val)
  }
})


const bodyStyle = computed(() => {
  const flexDirections = {
    right: 'row-reverse',
    left: 'row',
    top: 'column',
    bottom: 'column-reverse'
  }
  return {
    flexDirection: flexDirections[props.titlePosition]
  }
})


</script>



<style scoped lang="scss">
.data-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px;
  border-radius: 20px;
}

.data-card__body {
  display: flex;
  gap: 4px;
}

.data-card__title {
  color: rgba(46, 46, 46, 0.70);
  // text-align: right;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.data-card__text {
  font-family: 'Gotham-Book';
  font-style: normal;
  font-weight: 300;
  font-size: 60px;
  color: #373737;
  margin-right: 4px;
}

.data-card__icon {
  width: 48px;
  height: 48px;
  text-align: center;
  // border: 1px solid blue;
  display: flex;
  align-items: center;
  justify-content: center;
}

.data-card__unit {
  font-size: 12px;
  font-weight: 300;
  color: rgba(46, 46, 46);
}
</style>
